import { render, staticRenderFns } from "./Studie.vue?vue&type=template&id=2bf478a5&"
import script from "./Studie.vue?vue&type=script&lang=js&"
export * from "./Studie.vue?vue&type=script&lang=js&"
import style0 from "./Studie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports